import React, { useState } from "react";
import { useData } from '../../context/DataContext';
import { Row, Col, Form, Card, Image } from "react-bootstrap";
import userProfileImg from '../../assets/icon-img.jpeg';
import CustomButton from "../../components/buttons/customButton";

function Profile() {
    const { user = {} } = useData();
    const [state, setState] = useState({
        userName: user?.name || "", userNameError: "",
        userMobile: user?.mobile_no || "", userMobileError: "",
        // userEmail: user?.email || "", userEmailError: "",
        userGender: user?.gender || "", userGenderError: "",
        userEducation: user?.education || "", userEducationError: "",
        userExperience: user?.experience || "", userExperienceError: "",
        isEditProfile: false, loading: false
    });

    console.log("isEditProfile",state.isEditProfile);
    

    const handleInputChange = (e, key) => {
        const { value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [key]: key === "userMobile" ? value.slice(0, 10) : key === "userExperience" ? value.slice(0, 2) : value,
            userNameError: "", userEmailError: "", userMobileError: "", userGenderError: "", userExperienceError: "", userEducationError: "",
        }));
    };

    const handleEditToggle = () => { setState(prevState => ({ ...prevState, isEditProfile: true })) };
    const handleSubmit = () => {
        let isValid = true; let newErrors = {};
        const mobileNumberRegex = /^[6-9]\d{9}$/;
        // const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        const validations = [
            { value: state.userName, errorField: "userNameError", message: "Enter User Name" },
            { value: state.userMobile, errorField: "userMobileError", message: "Enter a valid Phone Number in 10 digits", validate: (value) => mobileNumberRegex.test(value) },
            // { value: state.userEmail, errorField: "userEmailError", message: "Email is required", validate: (value) => !value || validRegex.test(value) },
            { value: state.userGender, errorField: "userGenderError", message: "Enter Gender" },
            { value: state.userEducation, errorField: "userEducationError", message: "Enter Education" },
            { value: state.userExperience, errorField: "userExperienceError", message: "Enter Experience" },
        ];
        validations.forEach(({ value, errorField, message, validate }) => {
            if (!value || (validate && !validate(value))) {
                newErrors[errorField] = message;
                isValid = false;
            } else {
                newErrors[errorField] = "";
            }
        });
        setState((prevState) => ({ ...prevState, ...newErrors }));
        if (isValid) {
            setState((prevState) => ({ ...prevState, loading: true }));
            let params = { "name": state.userName, "mobile": state.userMobile, "gender": state.userGender, "education": state.userEducation, "experience": state.userExperience };
            
        }
    };

    const userProfile = [
        { id: 1, label: "Name", type: "text", value: state.userName, key: "userName", placeholder: "Enter User Name" },
        { id: 2, label: "Mobile", type: "number", value: state.userMobile, key: "userMobile", placeholder: "Enter User Number" },
        // { id: 3, label: "Email", type: "email", value: state.userEmail, key: "userEmail", placeholder: "Enter User Email" },
        { id: 4, label: "Gender", type: "text", value: state.userGender, key: "userGender", placeholder: "Enter Gender" },
        { id: 5, label: "Education", type: "text", value: state.userEducation, key: "userEducation", placeholder: "Enter Education" },
        { id: 6, label: "Experience", type: "number", value: state.userExperience, key: "userExperience", placeholder: "Enter Experience" },
    ];

    const validationMessages = (validate) => {
        const errorMapping = { 1: state.userNameError, 2: state.userMobileError, 4: state.userGenderError, 5: state.userEducationError, 6: state.userExperienceError };
        return errorMapping[validate] || ""
    };

    return (
        <div>
            {/* <Card>
                <Card.Body>
                    <Row>
                        <Col sm={3} className="text-center mt-5"><Image src={userProfileImg} width={250} height={150} className="rounded-circle mt-5 text-center" /></Col>
                        <Col sm={9}>
                            <Row>{userProfile.map(({ id, label, type, key, placeholder }) => (
                                <Col sm={12} className="mt-2" key={id} style={{ borderLeft: "1px solid rgb(33, 48, 70)" }}>
                                    <Form>
                                        <Form.Group controlId={`form${label}`}>
                                            <Form.Label className="fw-bold text-uppercase">{label}&nbsp;<Form.Text className="text-danger">{validationMessages(id)}</Form.Text></Form.Label>
                                            <Form.Control className="w-100" type={type} value={state[key]} placeholder={placeholder} onChange={(e) => handleInputChange(e, key)} disabled={!state.isEditProfile} />
                                        </Form.Group>
                                    </Form>
                                </Col>
                            ))}
                                <Col sm={12} className="text-center">
                                    <CustomButton loading={state.loading} type="submit" className="bg mt-3 w-50"  onClick={state.isEditProfile ? handleSubmit : handleEditToggle} iconClass={state.isEditProfile ? "fa fa-paper-plane" : "fas fa-edit"}>
                                        {state.isEditProfile ? "Submit Profile" : "Edit Profile"}
                                    </CustomButton>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
            </Card> */}
        </div>
    );
}
export default Profile;